type ReissueConfigReadyArgs = {
  surveyDoc: unknown;
  formConfigDoc: unknown;
  floorPlansConfigDoc: unknown;
};

function isResolved(doc: unknown) {
  return typeof doc !== 'undefined';
}

export function isReissueConfigReady({
  surveyDoc,
  formConfigDoc,
  floorPlansConfigDoc,
}: ReissueConfigReadyArgs) {
  return (
    isResolved(surveyDoc) &&
    isResolved(formConfigDoc) &&
    isResolved(floorPlansConfigDoc)
  );
}
